import api from "@/api.js";

export default {
  state: {
    loot: [],
    lootLoading: false
  },
  mutations: {
    setLoot(state, payload) {
      state.loot = payload;
    },
    setLootLoading(state, payload) {
      state.lootLoading = payload;
    }
  },
  actions: {
    async loadLoot({ commit, state }) {
      let loot;

      loot = await api.get("loot");

      commit("setLoot", loot.data);
    },
    async addLoot({ dispatch }, payload) {
      let loot;

      loot = await api.post("loot", payload);

      dispatch("loadLoot");

      return loot;
    },
    async saveLoot({ dispatch }, payload) {
      let loot;

      loot = await api.put("loot", payload);

      return loot;
    },
    async removeLoot({ dispatch }, payload) {
      let loot;

      loot = await api.post("loot/remove", payload);

      dispatch("loadLoot");

      return loot;
    }
  },
  getters: {
    loot(state) {
      return state.loot;
    },
    lootLoading(state) {
      return state.lootLoading;
    }
  }
};
